import { render, staticRenderFns } from "./InformManagement.vue?vue&type=template&id=2775ab78&scoped=true"
import script from "./InformManagement.vue?vue&type=script&lang=js"
export * from "./InformManagement.vue?vue&type=script&lang=js"
import style0 from "./InformManagement.vue?vue&type=style&index=0&id=2775ab78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2775ab78",
  null
  
)

export default component.exports